import {
  type AttrTrackingMap,
  type TrkAction,
} from '@unisporkal/attr-tracking';

export const landingAttrTrackingMap: AttrTrackingMap = {
  mfeId: 'landing',
  events: {
    // AI-free hero on the Getty creative homepage; one link, so a static payload.
    ai_free_hero_cta: () => ({
      event: 'cta_interaction',
      event_name: 'cta_clicked',
      cta_interaction: 'cta_clicked',
      cta_selection: undefined,
      cta_text: 'learn_more_about_how_we_keep_our_library_ai_free',
      ui_element_location: 'hp_hero_banner',
    }),
    // Getty AI pages sub-nav; one handler for every tab.
    ai_sub_nav_tab: (action: TrkAction) => ({
      event: 'navigation',
      event_model: 'navigation',
      event_name: 'navigation',
      link_text: action.context.linkText,
      // Reverses the write-side ';' escape (data-trk-action-context's own pair delimiter).
      link_url: decodeURIComponent(action.context.linkUrl as string),
      navigation_selection: 'ai_generator',
      ui_element_location: 'header_sub_nav',
    }),
    // "Explore other subscriptions" on the iStock AI bundle card.
    ai_bundle_explore_subscriptions: (action: TrkAction) => ({
      event: 'cta_interaction',
      event_name: 'cta_clicked',
      cta_interaction: 'cta_clicked',
      cta_selection: undefined,
      cta_text: 'explore_other_subscriptions',
      // Reverses the write-side encoding of ';', the context pair delimiter.
      cta_url: decodeURIComponent(String(action.context.ctaUrl)),
      download_flow: 'gen_ai_bundle',
      ui_element_location: 'hero_banner',
      item_id: null,
    }),
  },
};

// Not empty: these events predate GA4DecouplingLanding and have no imperative
// twin, so they must keep firing with the flag off. A constant, not built per
// call: AttrTrackingProvider re-registers on identity.
const FLAG_OFF_MAP: AttrTrackingMap = {
  mfeId: 'landing',
  events: {
    ai_free_hero_cta: landingAttrTrackingMap.events.ai_free_hero_cta,
  },
};

export const getAttrTrackingMap = (isFlagEnabled = false) =>
  isFlagEnabled ? landingAttrTrackingMap : FLAG_OFF_MAP;
